import { render, staticRenderFns } from "./WriteReview.vue?vue&type=template&id=4e901a88&scoped=true&"
import script from "./WriteReview.vue?vue&type=script&lang=js&"
export * from "./WriteReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e901a88",
  null
  
)

export default component.exports